module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.nezet.tipus == 'urlap'),
      expression: "nezet.tipus == 'urlap'"
    }]
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6"
  }, [_c('inputbox', {
    attrs: {
      "errors": _vm.errors,
      "id": "nev",
      "name": "nev",
      "disabled": "",
      "label": "Név"
    },
    model: {
      value: (_vm.form.values.nev),
      callback: function($$v) {
        _vm.form.values.nev = $$v
      },
      expression: "form.values.nev"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6"
  }, [_c('inputbox', {
    attrs: {
      "errors": _vm.errors,
      "id": "neptunkod",
      "name": "neptunkod",
      "disabled": "",
      "label": "Neptun azonosító"
    },
    model: {
      value: (_vm.form.values.neptunkod),
      callback: function($$v) {
        _vm.form.values.neptunkod = $$v
      },
      expression: "form.values.neptunkod"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6"
  }, [_c('inputbox', {
    attrs: {
      "errors": _vm.errors,
      "id": "szuletesiHely",
      "name": "szuletesiHely",
      "disabled": "",
      "label": "Születési hely"
    },
    model: {
      value: (_vm.form.values.szuletesiHely),
      callback: function($$v) {
        _vm.form.values.szuletesiHely = $$v
      },
      expression: "form.values.szuletesiHely"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6"
  }, [_c('inputbox', {
    attrs: {
      "errors": _vm.errors,
      "id": "szuletesiIdo",
      "name": "szuletesiIdo",
      "disabled": "",
      "label": "Születési idő"
    },
    model: {
      value: (_vm.form.values.szuletesiIdo),
      callback: function($$v) {
        _vm.form.values.szuletesiIdo = $$v
      },
      expression: "form.values.szuletesiIdo"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6"
  }, [_c('inputbox', {
    attrs: {
      "errors": _vm.errors,
      "id": "anyjaNeve",
      "name": "anyjaNeve",
      "disabled": "",
      "label": "Anyja neve"
    },
    model: {
      value: (_vm.form.values.anyjaNeve),
      callback: function($$v) {
        _vm.form.values.anyjaNeve = $$v
      },
      expression: "form.values.anyjaNeve"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6"
  }, [_c('inputbox', {
    attrs: {
      "errors": _vm.errors,
      "id": "telefonszam",
      "name": "telefonszam",
      "disabled": "",
      "label": "Telefonszám"
    },
    model: {
      value: (_vm.form.values.telefonszam),
      callback: function($$v) {
        _vm.form.values.telefonszam = $$v
      },
      expression: "form.values.telefonszam"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6"
  }, [_c('inputbox', {
    attrs: {
      "errors": _vm.errors,
      "id": "emailCim",
      "name": "emailCim",
      "disabled": "",
      "label": "E-mail cím"
    },
    model: {
      value: (_vm.form.values.emailCim),
      callback: function($$v) {
        _vm.form.values.emailCim = $$v
      },
      expression: "form.values.emailCim"
    }
  })], 1), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('comboboxV2', {
    attrs: {
      "errors": _vm.errors,
      "label": "Képzések",
      "id": "kepzesKodja",
      "options": _vm.kepzesek
    },
    on: {
      "onChange": _vm.kepzesValt
    },
    model: {
      value: (_vm.form.values.kivalasztottKepzesKodja),
      callback: function($$v) {
        _vm.form.values.kivalasztottKepzesKodja = $$v
      },
      expression: "form.values.kivalasztottKepzesKodja"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6"
  }, [_c('inputbox', {
    attrs: {
      "errors": _vm.errors,
      "id": "kar",
      "name": "kar",
      "disabled": "",
      "label": "Kar neve"
    },
    model: {
      value: (_vm.form.values.kar),
      callback: function($$v) {
        _vm.form.values.kar = $$v
      },
      expression: "form.values.kar"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6"
  }, [_c('inputbox', {
    attrs: {
      "errors": _vm.errors,
      "id": "tagozat",
      "name": "tagozat",
      "disabled": "",
      "label": "Tagozat"
    },
    model: {
      value: (_vm.form.values.tagozat),
      callback: function($$v) {
        _vm.form.values.tagozat = $$v
      },
      expression: "form.values.tagozat"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6"
  }, [_c('inputbox', {
    attrs: {
      "errors": _vm.errors,
      "id": "kepzesNeve",
      "name": "kepzesNeve",
      "disabled": "",
      "label": "Képzés"
    },
    model: {
      value: (_vm.form.values.kepzesNeve),
      callback: function($$v) {
        _vm.form.values.kepzesNeve = $$v
      },
      expression: "form.values.kepzesNeve"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6"
  }, [_c('inputbox', {
    attrs: {
      "errors": _vm.errors,
      "id": "kepzesKodja",
      "name": "kepzesKodja",
      "disabled": "",
      "label": "Képzés kódja"
    },
    model: {
      value: (_vm.form.values.kepzesKodja),
      callback: function($$v) {
        _vm.form.values.kepzesKodja = $$v
      },
      expression: "form.values.kepzesKodja"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6"
  }, [_c('inputbox', {
    attrs: {
      "errors": _vm.errors,
      "id": "kepzesSzintje",
      "name": "kepzesSzintje",
      "disabled": "",
      "label": "Képzés szintje"
    },
    model: {
      value: (_vm.form.values.kepzesSzintje),
      callback: function($$v) {
        _vm.form.values.kepzesSzintje = $$v
      },
      expression: "form.values.kepzesSzintje"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6"
  }, [_c('inputbox', {
    attrs: {
      "errors": _vm.errors,
      "id": "hallgatoiStatusz",
      "name": "hallgatoiStatusz",
      "disabled": "",
      "label": "Hallgatói státusz"
    },
    model: {
      value: (_vm.form.values.hallgatoiStatusz),
      callback: function($$v) {
        _vm.form.values.hallgatoiStatusz = $$v
      },
      expression: "form.values.hallgatoiStatusz"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6"
  }, [_c('inputbox', {
    attrs: {
      "errors": _vm.errors,
      "id": "kepzesHelye",
      "name": "kepzesHelye",
      "disabled": "",
      "label": "Képzés helye"
    },
    model: {
      value: (_vm.form.values.kepzesHelye),
      callback: function($$v) {
        _vm.form.values.kepzesHelye = $$v
      },
      expression: "form.values.kepzesHelye"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6"
  }, [_c('inputbox', {
    attrs: {
      "errors": _vm.errors,
      "id": "penzugyiStatusz",
      "name": "penzugyiStatusz",
      "disabled": "",
      "label": "Pénzügyi státusz"
    },
    model: {
      value: (_vm.form.values.penzugyiStatusz),
      callback: function($$v) {
        _vm.form.values.penzugyiStatusz = $$v
      },
      expression: "form.values.penzugyiStatusz"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6"
  }, [_c('inputbox', {
    attrs: {
      "errors": _vm.errors,
      "id": "osztondijindex",
      "name": "osztondijindex",
      "disabled": "",
      "label": "Ösztöndíjindex"
    },
    model: {
      value: (_vm.form.values.osztondijindex),
      callback: function($$v) {
        _vm.form.values.osztondijindex = $$v
      },
      expression: "form.values.osztondijindex"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('inputbox', {
    attrs: {
      "regexp_filter": "[0-9]+",
      "errors": _vm.errors,
      "id": "felevekSzama",
      "name": "felevekSzama",
      "label": "Hányadik félévedet töltöd az egyetemen?"
    },
    model: {
      value: (_vm.form.values.felevekSzama),
      callback: function($$v) {
        _vm.form.values.felevekSzama = $$v
      },
      expression: "form.values.felevekSzama"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row",
    class: {
      'grid-row-disabled': parseInt(_vm.form.values.felevekSzama) <= 1 || _vm.form.values.felevekSzama == ''
    }
  }, [_vm._m(4), _vm._v(" "), _vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('inputbox', {
    attrs: {
      "errors": _vm.errors,
      "id": "tudomanyosTevekenyseg",
      "name": "tudomanyosTevekenyseg",
      "label": "Milyen tevékenységet folytat?"
    },
    model: {
      value: (_vm.form.values.tudomanyosTevekenyseg),
      callback: function($$v) {
        _vm.form.values.tudomanyosTevekenyseg = $$v
      },
      expression: "form.values.tudomanyosTevekenyseg"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-4"
  }, [_c('inputbox', {
    attrs: {
      "errors": _vm.errors,
      "id": "tudomanyosElertEredmeny",
      "name": "tudomanyosElertEredmeny",
      "label": "Elért eredmény"
    },
    model: {
      value: (_vm.form.values.tudomanyosElertEredmeny),
      callback: function($$v) {
        _vm.form.values.tudomanyosElertEredmeny = $$v
      },
      expression: "form.values.tudomanyosElertEredmeny"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-4"
  }, [_c('inputbox', {
    attrs: {
      "errors": _vm.errors,
      "id": "tudomanyosVersenyMegnevezese",
      "name": "tudomanyosVersenyMegnevezese",
      "label": "Verseny megnevezése"
    },
    model: {
      value: (_vm.form.values.tudomanyosVersenyMegnevezese),
      callback: function($$v) {
        _vm.form.values.tudomanyosVersenyMegnevezese = $$v
      },
      expression: "form.values.tudomanyosVersenyMegnevezese"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-4"
  }, [_c('inputbox', {
    attrs: {
      "errors": _vm.errors,
      "id": "tudomanyosElertHelyezes",
      "name": "tudomanyosElertHelyezes",
      "label": "Elért helyezés"
    },
    model: {
      value: (_vm.form.values.tudomanyosElertHelyezes),
      callback: function($$v) {
        _vm.form.values.tudomanyosElertHelyezes = $$v
      },
      expression: "form.values.tudomanyosElertHelyezes"
    }
  })], 1), _vm._v(" "), _vm._m(6), _vm._v(" "), _c('div', {
    staticClass: "col-xs-4"
  }, [_c('inputbox', {
    attrs: {
      "errors": _vm.errors,
      "id": "tudomanyosVersenyCsapatnev",
      "name": "tudomanyosVersenyCsapatnev",
      "label": "Versenycsapat neve"
    },
    model: {
      value: (_vm.form.values.tudomanyosVersenyCsapatnev),
      callback: function($$v) {
        _vm.form.values.tudomanyosVersenyCsapatnev = $$v
      },
      expression: "form.values.tudomanyosVersenyCsapatnev"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-4"
  }, [_c('inputbox', {
    attrs: {
      "errors": _vm.errors,
      "id": "tudomanyosVersenyCsapatBetoltottPozicio",
      "name": "tudomanyosVersenyCsapatBetoltottPozicio",
      "label": "Betöltött pozíció"
    },
    model: {
      value: (_vm.form.values.tudomanyosVersenyCsapatBetoltottPozicio),
      callback: function($$v) {
        _vm.form.values.tudomanyosVersenyCsapatBetoltottPozicio = $$v
      },
      expression: "form.values.tudomanyosVersenyCsapatBetoltottPozicio"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-4"
  }, [_c('inputbox', {
    attrs: {
      "errors": _vm.errors,
      "id": "tudomanyosVersenyCsapatTagsagKezdete",
      "name": "tudomanyosVersenyCsapatTagsagKezdete",
      "label": "Tagság kezdete (félévre nézve)"
    },
    model: {
      value: (_vm.form.values.tudomanyosVersenyCsapatTagsagKezdete),
      callback: function($$v) {
        _vm.form.values.tudomanyosVersenyCsapatTagsagKezdete = $$v
      },
      expression: "form.values.tudomanyosVersenyCsapatTagsagKezdete"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('inputbox', {
    attrs: {
      "errors": _vm.errors,
      "id": "tudomanyosEgyetemJoHire",
      "name": "tudomanyosEgyetemJoHire",
      "label": "Tevékenységével hogyan és mi módon gyarapította az Egyetem jó hírét?"
    },
    model: {
      value: (_vm.form.values.tudomanyosEgyetemJoHire),
      callback: function($$v) {
        _vm.form.values.tudomanyosEgyetemJoHire = $$v
      },
      expression: "form.values.tudomanyosEgyetemJoHire"
    }
  })], 1), _vm._v(" "), _vm._m(7), _vm._v(" "), _vm._m(8), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('inputbox', {
    attrs: {
      "errors": _vm.errors,
      "id": "kulturalisTevekenyseg",
      "name": "kulturalisTevekenyseg",
      "label": "Milyen tevékenységet folytat?"
    },
    model: {
      value: (_vm.form.values.kulturalisTevekenyseg),
      callback: function($$v) {
        _vm.form.values.kulturalisTevekenyseg = $$v
      },
      expression: "form.values.kulturalisTevekenyseg"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('inputbox', {
    attrs: {
      "regexp_filter": "[0-9]+",
      "errors": _vm.errors,
      "id": "kulturalisTevekenysegEvszam",
      "name": "kulturalisTevekenysegEvszam",
      "label": "Mióta végzi a tevékenységet? (évszámra pontosan)"
    },
    model: {
      value: (_vm.form.values.kulturalisTevekenysegEvszam),
      callback: function($$v) {
        _vm.form.values.kulturalisTevekenysegEvszam = $$v
      },
      expression: "form.values.kulturalisTevekenysegEvszam"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-4"
  }, [_c('inputbox', {
    attrs: {
      "errors": _vm.errors,
      "id": "kulturalisElertEredmeny",
      "name": "kulturalisElertEredmeny",
      "label": "Elért eredmény"
    },
    model: {
      value: (_vm.form.values.kulturalisElertEredmeny),
      callback: function($$v) {
        _vm.form.values.kulturalisElertEredmeny = $$v
      },
      expression: "form.values.kulturalisElertEredmeny"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-4"
  }, [_c('inputbox', {
    attrs: {
      "errors": _vm.errors,
      "id": "kulturalisMegmerettetesMegnevezese",
      "name": "kulturalisMegmerettetesMegnevezese",
      "label": "Megmérettetés megnevezése"
    },
    model: {
      value: (_vm.form.values.kulturalisMegmerettetesMegnevezese),
      callback: function($$v) {
        _vm.form.values.kulturalisMegmerettetesMegnevezese = $$v
      },
      expression: "form.values.kulturalisMegmerettetesMegnevezese"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-4"
  }, [_c('inputbox', {
    attrs: {
      "errors": _vm.errors,
      "id": "kulturalisElertHelyezes",
      "name": "kulturalisElertHelyezes",
      "label": "Elért helyezés"
    },
    model: {
      value: (_vm.form.values.kulturalisElertHelyezes),
      callback: function($$v) {
        _vm.form.values.kulturalisElertHelyezes = $$v
      },
      expression: "form.values.kulturalisElertHelyezes"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('inputbox', {
    attrs: {
      "errors": _vm.errors,
      "id": "kulturalisEgyetemJoHire",
      "name": "kulturalisEgyetemJoHire",
      "label": "Tevékenységével hogyan és mi módon gyarapította az Egyetem jó hírét?"
    },
    model: {
      value: (_vm.form.values.kulturalisEgyetemJoHire),
      callback: function($$v) {
        _vm.form.values.kulturalisEgyetemJoHire = $$v
      },
      expression: "form.values.kulturalisEgyetemJoHire"
    }
  })], 1), _vm._v(" "), _vm._m(9), _vm._v(" "), _vm._m(10), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('inputbox', {
    attrs: {
      "errors": _vm.errors,
      "id": "sportTevekenyseg",
      "name": "sportTevekenyseg",
      "label": "Milyen tevékenységet folytat?"
    },
    model: {
      value: (_vm.form.values.sportTevekenyseg),
      callback: function($$v) {
        _vm.form.values.sportTevekenyseg = $$v
      },
      expression: "form.values.sportTevekenyseg"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('inputbox', {
    attrs: {
      "regexp_filter": "[0-9]+",
      "errors": _vm.errors,
      "id": "sportTevekenysegEvszam",
      "name": "sportTevekenysegEvszam",
      "label": "Mióta végzi a tevékenységet? (évszámra pontosan)"
    },
    model: {
      value: (_vm.form.values.sportTevekenysegEvszam),
      callback: function($$v) {
        _vm.form.values.sportTevekenysegEvszam = $$v
      },
      expression: "form.values.sportTevekenysegEvszam"
    }
  })], 1), _vm._v(" "), _vm._m(11), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('table', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.form.values.sportVersenyek.length > 0),
      expression: "form.values.sportVersenyek.length > 0"
    }],
    staticClass: "list-table"
  }, [_vm._m(12), _vm._v(" "), _vm._l((_vm.form.values.sportVersenyek), function(sv, i) {
    return _c('tr', {
      key: 'sv_' + i
    }, [_c('td', [_c('inputbox', {
      staticStyle: {
        "padding-bottom": "0px"
      },
      attrs: {
        "datepicker": true,
        "errors": _vm.errors,
        "id": 'sv_datum_' + i,
        "label": "",
        "name": 'sv_datum_' + i
      },
      model: {
        value: (sv.datum),
        callback: function($$v) {
          sv.datum = $$v
        },
        expression: "sv.datum"
      }
    })], 1), _vm._v(" "), _c('td', [_c('inputbox', {
      staticStyle: {
        "padding-bottom": "0px"
      },
      attrs: {
        "errors": _vm.errors,
        "id": 'sv_megnevezes_' + i,
        "label": "",
        "name": 'sv_megnevezes_' + i
      },
      model: {
        value: (sv.megnevezes),
        callback: function($$v) {
          sv.megnevezes = $$v
        },
        expression: "sv.megnevezes"
      }
    })], 1), _vm._v(" "), _c('td', [_c('inputbox', {
      staticStyle: {
        "padding-bottom": "0px"
      },
      attrs: {
        "regexp_filter": "[0-9]+",
        "errors": _vm.errors,
        "id": 'sv_helyezes_' + i,
        "label": "",
        "name": 'sv_helyezes_' + i
      },
      model: {
        value: (sv.helyezes),
        callback: function($$v) {
          sv.helyezes = $$v
        },
        expression: "sv.helyezes"
      }
    })], 1), _vm._v(" "), _c('td', [_c('comboboxV2', {
      staticStyle: {
        "padding-bottom": "0px"
      },
      attrs: {
        "errors": _vm.errors,
        "label": "",
        "id": 'sv_szint_' + i,
        "options": _vm.verseny_szintek
      },
      model: {
        value: (sv.szint),
        callback: function($$v) {
          sv.szint = $$v
        },
        expression: "sv.szint"
      }
    })], 1), _vm._v(" "), _c('td', [_c('button', {
      staticClass: "button only-icon",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.versenyTorol(i)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash"
    })])])])
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('button', {
    staticClass: "button only-icon",
    attrs: {
      "disabled": _vm.form.values.sportVersenyek.length >= 9,
      "type": "button"
    },
    on: {
      "click": _vm.versenyHozzaad
    }
  }, [_vm._v("+")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('inputbox', {
    attrs: {
      "errors": _vm.errors,
      "id": "sportEgyetemJoHire",
      "name": "sportEgyetemJoHire",
      "label": "Tevékenységével hogyan és mi módon gyarapította az Egyetem jó hírét?"
    },
    model: {
      value: (_vm.form.values.sportEgyetemJoHire),
      callback: function($$v) {
        _vm.form.values.sportEgyetemJoHire = $$v
      },
      expression: "form.values.sportEgyetemJoHire"
    }
  })], 1), _vm._v(" "), _vm._m(13), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "form-checkbox-wrapper"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.values.nyilatkozatElfogadas),
      expression: "form.values.nyilatkozatElfogadas"
    }],
    attrs: {
      "true-value": "1",
      "false-value": "0",
      "id": "nyilatkozatElfogadas",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.form.values.nyilatkozatElfogadas) ? _vm._i(_vm.form.values.nyilatkozatElfogadas, null) > -1 : _vm._q(_vm.form.values.nyilatkozatElfogadas, "1")
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.form.values.nyilatkozatElfogadas,
          $$el = $event.target,
          $$c = $$el.checked ? ("1") : ("0");
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.form.values.nyilatkozatElfogadas = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.form.values.nyilatkozatElfogadas = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.form.values.nyilatkozatElfogadas = $$c
        }
      }
    }
  }), _vm._v(" "), _vm._m(14)]), _vm._v(" "), _vm._l((_vm.errors), function(error, i) {
    return (error.id == 'nyilatkozatElfogadas') ? _c('div', {
      staticClass: "form-error"
    }, [_vm._v(_vm._s(error.msg))]) : _vm._e()
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticStyle: {
      "display": "flex",
      "justify-content": "space-between",
      "align-items": "center"
    }
  }, [_c('button', {
    staticClass: "button",
    attrs: {
      "disabled": _vm.mentes_folyamatban,
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.save(0)
      }
    }
  }, [_vm._v("Mentés")]), _vm._v(" "), _c('button', {
    staticClass: "button",
    attrs: {
      "disabled": _vm.mentes_folyamatban,
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.saveConfirm(1)
      }
    }
  }, [_vm._v("Véglegesít")])])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.nezet.tipus == 'info'),
      expression: "nezet.tipus == 'info'"
    }]
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "form-title"
  }, [_vm._v("\n            Kiemelkedő tudományos, sport vagy kulturális tevékenységért járó ösztöndíj\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "article-text",
    domProps: {
      "innerHTML": _vm._s(_vm.nezet.tartalom)
    }
  })])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "form-title"
  }, [_vm._v("\n            Kiemelkedő tudományos, sport vagy kulturális tevékenységért járó ösztöndíj\n          ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "info-box warning"
  }, [_vm._v("\n            Amennyiben hibát talál "), _c('span', {
    staticClass: "highlight"
  }, [_vm._v("személyes")]), _vm._v(" vagy "), _c('span', {
    staticClass: "highlight"
  }, [_vm._v("képzési adataiban")]), _vm._v(", kérjük lépjen kapcsolatba a tanulmányi ügyintézővel.\n          ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12"
  }, [_c('h5', {
    staticClass: "form-block-title",
    staticStyle: {
      "margin-top": "0px"
    }
  }, [_vm._v("\n            Személyes adatok\n          ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12"
  }, [_c('h5', {
    staticClass: "form-block-title",
    staticStyle: {
      "margin-top": "0px"
    }
  }, [_vm._v("\n            Képzési adatok\n          ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12"
  }, [_c('h5', {
    staticClass: "form-block-title",
    staticStyle: {
      "margin-top": "0px"
    }
  }, [_vm._v("\n            Kiemelkedő tehetséggondozási tevékenységért járó ösztöndíj\n          ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "info-box warning"
  }, [_vm._v("\n            Tehetséggondozó műhely: A hallgató benyújthatja, ha tagja egy versenycsapatnak vagy egy szakkollégiumnak, helyezést ért el a legutóbbi TDK-n vagy OTDK-n, részt vett más szakmai versenyen, illetve publikációt jelentetett meg.\n          ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "info-box warning"
  }, [_vm._v("\n            Amennyiben verseny csapatban tevékenykedik\n          ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12"
  }, [_c('h5', {
    staticClass: "form-block-title",
    staticStyle: {
      "margin-top": "0px"
    }
  }, [_vm._v("\n            Kiemelkedő kulturális tevékenységért járó ösztöndíj\n          ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "info-box warning"
  }, [_vm._v("\n            A hallgató benyújthatja, ha kiemelkedően teljesít képzőművészet, zenekari és szóló hangszerek területén.\n          ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12"
  }, [_c('h5', {
    staticClass: "form-block-title",
    staticStyle: {
      "margin-top": "0px"
    }
  }, [_vm._v("\n            Kiemelkedő sport tevékenységért járó ösztöndíj\n          ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "info-box warning"
  }, [_vm._v("\n            A hallgató benyújthatja, ha kiemelkedően teljesít klasszikus sport és az e-sport területén.\n          ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "info-box warning"
  }, [_vm._v("\n            Elért sporteredmények\n          ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('th', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v("Verseny dátuma")]), _vm._v(" "), _c('th', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v("Verseny megnevezése")]), _vm._v(" "), _c('th', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v("Helyezés")]), _vm._v(" "), _c('th', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v("Milyen szinten elért eredmény?")]), _vm._v(" "), _c('th')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12"
  }, [_c('h5', {
    staticClass: "form-block-title",
    staticStyle: {
      "margin-top": "0px"
    }
  }, [_vm._v("\n            Hallgatói nyiltakozat\n          ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    attrs: {
      "for": "nyilatkozatElfogadas"
    }
  }, [_c('div', {
    staticClass: "icon"
  }), _vm._v("\n                A pályázat benyújtásával büntetőjogi felelősségem teljes tudatában kijelentem, hogy hamis adatok közlése esetén fegyelmi eljárás indulhat ellenem, mely a hallgatói jogviszony fegyelmi úton történő megszüntetését is eredményezheti. Továbbá hozzájárulok ahhoz, hogy adataimat a Széchenyi István Egyetem Hallgatói Önkormányzata nevében eljáró személyek a pályázat elbírálásával összefüggésben, a TJSZ-ben rögzített feltételeknek, illetve a személyi adatok védelméről és a közérdekű adatok nyilvánosságáról szóló 1992. évi LXIII. törvénynek megfelelően kezelje.\n              ")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7c7b80b6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./components/competition/kiemelkedo_tudomanyos_sport_kulturalis_osztondij.vue
// module id = 389
// module chunks = 0